module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_EIHK.821bd22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_EIHK.png
// module id = 52
// module chunks = 0